import { useForm } from 'react-hook-form'
import { Button } from 'ui'
import { Input } from 'ui/fields'
import { refreshToken } from '../../features/authSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

export type LoginFormValues = {
   email: string
   password: string
}

export type Profile = {
   accounts: Array<{
      code: string
      name: string
   }>
   email: string
   locale: string
   name: string
   roles: Array<{ code: string; name: string }>
   permissions: Array<{ code: string; name: string }>
   timeZone?: string
}

const Login = () => {
   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
   const {
      register,
      handleSubmit,
      formState: { errors, dirtyFields },
   } = useForm<LoginFormValues>()
   const dispatch = useAppDispatch()
   const { hasError, isRefreshing, statusText } = useAppSelector((state) => state.authToken)

   function onSubmit(data: LoginFormValues) {
      dispatch(refreshToken({ username: data.email, password: data.password }))
   }
   return (
      <div className="flex items-center justify-center h-screen">
         <div className="lg:w-4/12 md:w-8/12 w-full border rounded p-6 bg-white shadow">
            <form onSubmit={handleSubmit(onSubmit)}>
               <Input
                  containerClassName="mb-4"
                  label="Email"
                  {...register('email', {
                     required: `Email is required`,
                     pattern: { value: emailPattern, message: `Invalid email` },
                  })}
                  error={errors?.email?.message}
                  isTouched={dirtyFields.email}
               />
               <Input
                  containerClassName="mb-4"
                  label="Password"
                  {...register('password', { required: `Password is required` })}
                  type="password"
                  error={errors?.password?.message}
                  isTouched={dirtyFields.password}
               />
               {hasError && <div className="text-red-500 text-sm">{statusText || 'Invalid email or password'}</div>}
               <div className="text-center pt-4">
                  <Button type="submit" disabled={isRefreshing}>
                     {isRefreshing ? 'Logging in...' : 'Login'}
                  </Button>
               </div>
            </form>
         </div>
      </div>
   )
}

export default Login
